var React = require('react');

function ShareSmall (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:none;stroke:#00338d;stroke-linejoin:round;}")),React.createElement("line",{"x1":"10.41","y1":"4.46","x2":"4.41","y2":"7.09","key":1}),React.createElement("line",{"x1":"10.41","y1":"10.46","x2":"4.41","y2":"7.84","key":2}),React.createElement("circle",{"cx":"12","cy":"4","r":"1.5","key":3}),React.createElement("circle",{"cx":"12","cy":"11","r":"1.5","key":4}),React.createElement("circle",{"cx":"3","cy":"7.5","r":"1.5","key":5})]);
}

ShareSmall.defaultProps = {"width":"15","height":"15","viewBox":"0 0 15 15"};

module.exports = ShareSmall;

ShareSmall.default = ShareSmall;
